import { Fab } from '@material-ui/core';
import React from 'react';

interface IProps {
  onClick: () => void;

  // is the button position fixed on the bottom right?
  isFixedButton?: boolean; // default = true
}

function getPositionStyle(isFixed: boolean | undefined): React.CSSProperties {
  if (isFixed || isFixed === undefined) {
    return {
      top: 'auto',
      right: 20,
      bottom: 20,
      left: 'auto',
      position: 'fixed',
    };
  }
  return {};
}

// Button which show the `Open Live Logs`
export function LiveLogsButton(props: IProps) {
  return (
    <Fab
      style={{
        margin: 0,
        ...getPositionStyle(props.isFixedButton),
      }}
      variant='extended'
      color='primary'
      onClick={() => props.onClick()}
    >
      Open Live logs
    </Fab>
  );
}
